<template>
    <TsTypography
      as="span"
      size="sm"
      :id="`chip-${random_id}`"
      :data-testid="props.dataTestid"
      :append-class="chip_classes"
  
  >
      <span>
    {{  props.label  }}
      </span>
    <TsIcon
        name="mdi:close"
        :data-testid="`remove-chip-${props.dataTestid}-icon`"
        :class="icon_classes"
        @click="handleRemoveChip(props.label)"
      />
    </TsTypography>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { twMerge } from "tailwind-merge";
import { useRandomUUID } from "~/composables/useRandomUUID";

type Props = {
  dataTestid?: string;
  label?: string;
  appendClass?: string;
  iconClass?: string;
  variant?: string;
  rounded?: "xs" | "sm" | "md" | "lg" ;

};
const props = defineProps<Props>();

const emit = defineEmits<{
  remove: [label: string];
}>();

// random ID for each Vue Instance
const random_id = ref<string>("");

onMounted(() => {
  random_id.value = useRandomUUID();
});

const handleRemoveChip = (label) => {
  emit("remove", label);
};

// Styles
const icon_classes = twMerge(
    'cursor-pointer text-black !size-4',
    props.variant === 'contrast' && 'text-natural-silver-grey',
    props.iconClass
)

const chip_classes = twMerge(
    'border border-natural-light-grey rounded-full px-2 py-1 mr-2 mb-2 inline-flex gap-1.5 items-center min-w-max font-semibold bg-white text-black',
    props.variant === 'contrast' && 'bg-[#2E2E2E] text-white border-0',
    props.rounded === 'sm' && 'rounded',
    props.appendClass
)


</script>
